import { Typography } from 'app/component-library-wave';
import { Button } from '@lyse-as/formds-react';
import { FetchStatus } from 'app/store/root-types';
import { useAppDispatch } from 'app/hooks/redux-thunk';
import { postponeInvoice } from 'app/store/actions/invoice-thunks';
import { useTranslation } from 'react-i18next';
import { getAnonymizedCurrentPageUrl, GtmElementCategory, GtmElementCta } from 'app/utils/gtm-tracking-utils';
import { getDataLayers } from 'app/utils/trackingService';

import styles from './invoice-postpone.module.scss';

interface Props {
  invoiceId: string;
  fetchStatus: FetchStatus;
}

export const ConfirmStep = ({ invoiceId, fetchStatus }: Props) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const handleClick = () => {
    getDataLayers().customEvents.pushButtonClickEvent({
      element_category: GtmElementCategory.INVOICE_POSTPONE,
      element_cta: GtmElementCta.INVOICE_POSTPONE_INVOICE_CONFIRM,
      page_url: getAnonymizedCurrentPageUrl(),
    });

    dispatch(postponeInvoice({ invoiceId }));
  };

  const handleBack = () => {
    history.back();
  };

  return (
    <>
      <Typography component="h1" variant="formds-altibox-header-tertiary" bold={true}>
        {t('pages.invoice.invoicePostpone.name')}
      </Typography>
      <div className={styles.messageContainer}>
        <Typography component="p" variant="formds-body">
          {t('pages.invoice.invoicePostpone.rules')}
        </Typography>
      </div>
      <div className={styles.buttonContainer}>
        <Button
          variant="filled"
          scheme="primary"
          disabled={fetchStatus === FetchStatus.PENDING}
          onClick={handleClick}
          style={{ width: '100%' }}
        >
          {t('pages.invoice.invoicePostpone.confirm')}
        </Button>
        <Button variant="outlined" scheme="primary" onClick={handleBack} style={{ width: '100%' }}>
          {t('pages.invoice.invoicePostpone.cancel')}
        </Button>
      </div>
    </>
  );
};
